import {
  SidebarBottom,
  SidebarButton,
  SidebarButtonLogo,
  SidebarButtonUser,
  SidebarUserMenu,
  UIAppContent,
  UIAppLayout,
  UIAppSidebar,
  useAuth,
  useTheme,
} from "@eventsquare/uikit";
import { Link, Outlet, useLocation } from "react-router-dom";

import {
  RiCoupon2Line,
  RiLockStarLine,
  RiMailSendLine,
  RiShoppingCartLine,
} from "@remixicon/react";
import { Suspense, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import i18n from "@/i18n";
import { PrintStatus } from "@components/PrintStatus/PrintStatus";

export const AppLayout = () => {
  const location = useLocation();
  const { toggleSidebar } = useTheme();
  const { t } = useTranslation("app_layout");

  const { user } = useAuth();

  const [userMenuOpen, setUserMenuOpen] = useState(false);
  const anchorRef = useRef(null);

  useEffect(() => {
    i18n.changeLanguage(user?.language || "en");
  }, [user?.language]);

  const handleToggleOpen = (e?: React.MouseEvent<HTMLButtonElement>) => {
    e?.stopPropagation();
    if (userMenuOpen) {
      // Close
      handleClose();
    } else {
      // Open
      setUserMenuOpen(true);
    }
  };

  const handleClose = () => {
    toggleSidebar();
    setUserMenuOpen(false);
  };

  // const handleToggleIntercom = () => {
  //   if (intercomOpen) {
  //     hide();
  //   } else {
  //     show();
  //   }
  // };

  // useEffect(() => {
  //   onShow(() => {
  //     setIntercomOpen(true);
  //   });
  //   onHide(() => {
  //     setIntercomOpen(false);
  //   });
  // }, []);

  return (
    <UIAppLayout>
      <UIAppSidebar variant="pos">
        <Link to="">
          <SidebarButtonLogo />
        </Link>
        <Link to="">
          <SidebarButton
            icon={RiShoppingCartLine}
            label={t("sidebar.channels")}
            active={
              location.pathname === "/" ||
              location.pathname.includes("/channel")
            }
          />
        </Link>
        <Link to="/orders">
          <SidebarButton
            icon={RiCoupon2Line}
            label={t("sidebar.orders")}
            active={location.pathname === "/orders"}
          />
        </Link>
        <Link to="/invitations">
          <SidebarButton
            icon={RiMailSendLine}
            label={t("sidebar.invitations")}
            active={location.pathname === "/invitations"}
          />
        </Link>
        <Link to="/carts">
          <SidebarButton
            icon={RiLockStarLine}
            label={t("sidebar.carts")}
            active={location.pathname === "/carts"}
          />
        </Link>
        <SidebarBottom>
          <PrintStatus />
          <SidebarButtonUser onClick={handleToggleOpen} ref={anchorRef} />
          <SidebarUserMenu
            open={userMenuOpen}
            anchorRef={anchorRef}
            onClose={handleClose}
            translations={{
              switch_account: t("sidebar.user_menu.switch_account"),
              logout: t("sidebar.user_menu.logout"),
              appearance: t("sidebar.user_menu.appearance"),
            }}
          />
        </SidebarBottom>
      </UIAppSidebar>
      <UIAppContent>
        <Suspense fallback={null}>
          <Outlet />
        </Suspense>
      </UIAppContent>
    </UIAppLayout>
  );
};
